export const GENDERS = ["Male", "Female"];
export const GUARDIAN_RELATIONS = [
    "Mother",
    "Father",
    "Guardian",
    "Grandparent",
    "Aunt",
    "Uncle",
    "Sibling",
    "Other",
];
export const ADMISSION_STATUSES = ["Active", "Transferred", "Dropped", "Graduated"];
export const YEAR_OF_STUDY_OPTIONS = [1, 2, 3, 4, 5];
export const SPONSOR_TYPES = ["Self-sponsored", "Government bursary", "Scholarship", "Student loan", "Other"];
export const MALAWI_DISTRICTS = [
    "Balaka",
    "Blantyre",
    "Chikwawa",
    "Chiradzulu",
    "Chitipa",
    "Dedza",
    "Dowa",
    "Karonga",
    "Kasungu",
    "Likoma",
    "Lilongwe",
    "Machinga",
    "Mangochi",
    "Mchinji",
    "Mulanje",
    "Mwanza",
    "Mzimba",
    "Neno",
    "Nkhata Bay",
    "Nkhotakota",
    "Nsanje",
    "Ntcheu",
    "Ntchisi",
    "Phalombe",
    "Rumphi",
    "Salima",
    "Thyolo",
    "Zomba",
];

export function getExamRegistrationField(selectedClass) {
    if (!selectedClass?.isExamClass) return null;
    const code = String(selectedClass.levelCode || "").trim();
    if (code === "Std8") {
        return { key: "pslceRegNumber", label: "PSLCE Registration Number" };
    }
    if (code === "Form2") {
        return { key: "jceRegNumber", label: "JCE Registration Number" };
    }
    if (code === "Form4") {
        return { key: "msceRegNumber", label: "MSCE Registration Number" };
    }
    return null;
}

export const INITIAL_STUDENT_ENROLLMENT_VALUES = {
    name: "",
    rollNum: "",
    password: "",
    sclassName: "",
    photoUrl: "",
    gender: "",
    dateOfBirth: "",
    nationality: "Malawian",
    district: "",
    admissionDate: "",
    admissionStatus: "Active",
    guardianName: "",
    guardianPhone: "",
    guardianRelation: "",
    secondaryGuardianPhone: "",
    studentPhone: "",
    guardianEmail: "",
    pslceRegNumber: "",
    jceRegNumber: "",
    msceRegNumber: "",
    studentRegNumber: "",
    programme: "",
    faculty: "",
    department: "",
    yearOfStudy: 1,
    gpa: "",
    sponsorType: "",
    nextOfKinName: "",
    nextOfKinPhone: "",
    nextOfKinRelation: "",
    residenceType: "Day",
    hostelId: "",
    hostelRoomId: "",
    bedLabel: "",
};
